import { NativeModules } from 'react-native';
export default NativeModules.ExponentUpdates || ({} as any);
